export default function (element) {
    const safeMargin = 32;

    const position = element && element.length
        ? element.offset().top
        : 0;

    const headerOffset = $('header').length
        ? $('header').outerHeight()
        : 0;

    $('html, body').animate({
        scrollTop: (position - headerOffset - safeMargin),
    }, 500);
    if (!element) {
        $('.logo-home').focus();
    }
}
